// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1sahd","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__37vfa"};